"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _importProduct = require("@/api/importProduct");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var DetailImportModal = /*#__PURE__*/function (_Vue) {
  function DetailImportModal() {
    var _this;
    (0, _classCallCheck2.default)(this, DetailImportModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, DetailImportModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", "");
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10,
      productId: ""
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    return _this;
  }
  (0, _inherits2.default)(DetailImportModal, _Vue);
  return (0, _createClass2.default)(DetailImportModal, [{
    key: "transformTable",
    get: function get() {
      var _this2 = this;
      var data = [];
      this.data.forEach(function (e) {
        e.total = e.amount * e.quantityImport;
        var quantityImport = _this2.data.filter(function (el) {
          return el.product.id == e.product.id;
        }).reduce(function (a, b) {
          return a.quantityImport + b.quantityImport;
        });
        e.quantityTotal = e.quantityStock + (quantityImport.quantityImport || quantityImport);
        e.dateLeft = _moment.default.unix(e.importProduct.dateDelivery).diff((0, _moment.default)(), "days");
        data.push(e);
      });
      return data;
    }
  }, {
    key: "formatDateDuration",
    value: function formatDateDuration(date) {
      if (!date) {
        return "Hôm nay";
      }
      return _moment.default.duration(date, "days").humanize(true);
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _importProduct.importProductApi.findAllDetail(this.query);
            case 2:
              res = _context.sent;
              this.data = res.data.detailProducts;
              this.total = res.data.total;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }, {
    key: "handleView",
    value: function handleView(data) {
      this.form = (0, _objectSpread2.default)({}, data);
      this.visible = true;
      this.query.productId = data.id;
      this.fetchData();
    }
  }]);
}(_vuePropertyDecorator.Vue);
DetailImportModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], DetailImportModal);
var _default = exports.default = DetailImportModal;